<template lang="jade">
    include ../../node_modules/tangram-ui/src/elements/tge-componenttitle/tge-componenttitle.jade
    .election-component_title
        template(v-if="isLive")
            +tge-componenttitle({
                live: true,
                title: '{{ title }}',
                'title_count': '{{ fineprint }}',
                customAttributes: {
                    ':tge-componenttitle-layout': 'layout',
                    ':no-title-count': '!fineprint'
                }
            })
        template(v-else)
            +tge-componenttitle({
                title: '{{ title }}',
                'title_count': '{{ fineprint }}',
                customAttributes: {
                    ':tge-componenttitle-layout': 'layout',
                    ':no-title-count': '!fineprint'
                }
            })
</template>

<script>
    export default {
        name: "GroupTitle",
        props: {
            title: {
                type: String,
            },
            layout: {
                type: String,
                default: "center"
            },
            year: {},
            fineprint: {
                type: String
            }
        },
        computed: {
            isLive: function() {
				return this.$store.getters.currentElection(this.year).live;
			}
        }
    }
</script>

<style lang="scss">
    @import "src/_commons/assets/scss/global-sass";
    .election-component_title {
        display: flex;
        // margin-top: $m-spacing;
        // margin-bottom: $m-spacing;
        .tge-componenttitle {
            flex-basis: 100%;
        }

        .tge-componenttitle_count { padding-bottom: 3px;}
        [no-title-count] .tge-componenttitle_count { display: none;}
    }

</style>



// WEBPACK FOOTER //
// GroupTitle.vue?79e79f16